import { AttachDocumentModalProps } from './AttachDocumentModal';
import { openModal } from '@core/components/ModalStack';

export async function openAttachDocumentModal(props: AttachDocumentModalProps) {
  const { AttachDocumentModal } = await import('./AttachDocumentModal');

  openModal(AttachDocumentModal, props);
}


